import { updateCollection } from '@wix/ambassador-stores-catalog-v1-product/http';
import { chunk as getChunks } from 'lodash';
import { fetchCategories } from '../new-infra-fetchers/fetch-categories';
import { buildCategoriesBulkUpdatePayload } from './build-payloads/bulk-update-categories-alt-text-payload-builder';
const BULK_LIMIT = 100;
const updateCollectionMethod = async (httpClient, errorHandler, request) => {
  const {
    withErrorHandler
  } = errorHandler;
  try {
    await withErrorHandler(async () => httpClient.request(updateCollection(request)), {
      errorCodesMap: {}
    });
    return {
      success: true
    };
  } catch (error) {
    return {
      success: false
    };
  }
};
export const updateCategoriesAltText = async (httpClient, errorHandler, altTextData) => {
  const {
    getResolvedError
  } = errorHandler;
  const entityIdsList = altTextData.map(item => item.entityId).filter(entityId => entityId !== undefined);
  try {
    const categories = await fetchCategories(httpClient, errorHandler, entityIdsList);
    const allFailedElements = [];
    const chunks = getChunks(altTextData, BULK_LIMIT);
    const categoriesMap = new Map(categories.map(category => [category.id, category]));
    const updatePromises = chunks.map(async chunk => {
      const payload = buildCategoriesBulkUpdatePayload(chunk, categoriesMap);
      const {
        collections
      } = payload;
      if (collections.length === 0) {
        return {
          failedElements: chunk,
          success: false
        };
      }
      const collectionsPromises = collections.map(request => updateCollectionMethod(httpClient, errorHandler, request));
      const results = await Promise.all(collectionsPromises);
      const success = results.every(result => result.success);
      if (!success) {
        const failedIndexes = results.map((result, index) => result.success ? undefined : index).filter(index => index !== undefined);
        const failedElementsChunk = chunk.filter((_, index) => failedIndexes.includes(index));
        allFailedElements.push(...failedElementsChunk);
      }
      return {
        success
      };
    });
    const results = await Promise.all(updatePromises);
    const overallSuccess = results.every(result => result.success);
    return {
      failedElements: allFailedElements,
      success: overallSuccess
    };
  } catch (error) {
    return {
      errorMessage: getResolvedError(error).message,
      failedElements: altTextData,
      success: false
    };
  }
};
//# sourceMappingURL=update-categories.js.map